export enum StowageRulesCheckType {
    Cargo,
    CargoOperation,
    CargoOperationTransit,
    Rotation,
}
